import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IAlternativeMedicineInvoice } from 'Context/AlternativeMedicine';
import { AlternativeMedicineSchema } from 'Modules/Reimbursements/AlternativeMedicine/AlternativeMedicineMain/NewInvoiceForm/Schema';

export const useAlternativeMedicineForm = (
  checkIfInvoiceExists: (invoiceNumber: string) => boolean,
  defaultValues?: IAlternativeMedicineInvoice
) => {
  const AlternativeMedicineForm = useForm<IAlternativeMedicineInvoice>({
    mode: 'all',
    resolver: yupResolver(AlternativeMedicineSchema(checkIfInvoiceExists)),
    defaultValues: defaultValues || {
      invoiceId: '',
      invoiceDate: null,
      invoiceTotal: null,
      vendorName: null,
      file: null,
    },
  });

  return {
    AlternativeMedicineForm,
  };
};
